<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane
        class="paddingBody content"
        :label="$t('Inicio')"
        :key="render"
      >
        <div class="content-username">
          <span class="username">
            <b>{{ username }}</b>
          </span>
          <br />
          <span style="font-size: 12px"
            >Usted ha ingresado a la plataforma con el siguiente rol</span
          >
        </div>
        <br />
        <div style="margin-left: 21px; max-width: 990px; font-size: 15px">
          <div style="margin-bottom: 6px">
            <b>
              <span>La faena en la que he ingresado es:</span>
            </b>
            <span style="margin-left: 10px">{{
              faenas[$store.getters.role.faena_id]
            }}</span>
            <br />
          </div>
          <div
            style="margin-bottom: 6px"
            v-if="$store.getters.role.area_id && !$store.getters.role.admin"
          >
            <b>
              <span>El área en la que he ingresado es:</span>
            </b>
            <span style="margin-left: 10px">{{
              areaName($store.getters.role.area_id)
            }}</span>
            <br />
          </div>
          <div
            style="margin-bottom: 6px"
            v-if="$store.getters.role.empresa_id && !$store.getters.role.admin"
          >
            <b>
              <span>La empresa en la que he ingresado es:</span>
            </b>
            <span style="margin-left: 10px">{{
              companyName($store.getters.role.empresa_id)
            }}</span>
            <br />
          </div>
          <div style="margin-bottom: 6px">
            <b>
              <span>Mi rol para evaluar los inventarios es:</span>
            </b>
            <span style="margin-left: 10px" v-if="!$store.getters.role.admin">{{
              bhpProfiles[$store.getters.role.role] || $store.getters.role.role
            }}</span>
            <span
              style="margin-left: 10px"
              v-if="$store.getters.role.admin === true"
              >Administrador del sistema</span
            >
          </div>
        </div>
        <br />
        <el-row>
          <el-col :md="hasTutorial() === false ? 17 : 24">
            <center v-if="loading">
              <br />
              <br />
              <Circle9 style="margin-bottom: 8px"></Circle9>
              <small>Cargando Datos ...</small>
              <br />
              <br />
            </center>
            <table
              v-else
              border="0"
              cellspacing="10"
              style="font-size: 13px"
              element-loading-text="Cargando información..."
              element-loading-background="rgba(255, 255, 255)"
            >
              <tr>
                <td></td>
                <td class="border color-bhp-text text-center">
                  {{ faenas[$store.getters.role.faena_id] }}
                </td>
                <td class="border color-bhp-text text-center">
                  Empresas Colaboradoras
                </td>
              </tr>
              <tr>
                <td
                  :class="{ border_red: step === 6 && hasTutorial() === false }"
                  style="background-color: #72a329; color: white"
                  class="border"
                >
                  N° de Inventarios Aprobados
                  <el-popover
                    placement="top-start"
                    title="N° de Inventarios Aprobados"
                    width="400"
                    trigger="hover"
                    :content="`Visualización de la cantidad de Inventarios aprobados asociados a su cuenta; que ya pasaron por los diferentes flujos de revisión y tienen todos sus riesgos aprobados`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td
                  :class="{ border_red: step === 6 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_aprobados.propios.count
                  }}
                </td>
                <td
                  :class="{ border_red: step === 6 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_aprobados.contratistas.count
                  }}
                </td>
              </tr>
              <tr>
                <td
                  :class="{ border_red: step === 1 && hasTutorial() === false }"
                  style="background-color: #3b5c0a; color: white"
                  class="border"
                >
                  N° de Inventarios Aprobados en Actualización
                  <el-popover
                    placement="top-start"
                    title="N° de Inventarios Aprobados en Actualización"
                    width="400"
                    trigger="hover"
                    :content="`Aquí usted podrá visualizar la cantidad de inventarios aprobados que se encuentran en proceso de modificación o bien ya modificados, pero en estado de revisión.`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td
                  :class="{ border_red: step === 1 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_aprobados_actualizacion.propios.count
                  }}
                </td>
                <td
                  :class="{ border_red: step === 1 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_aprobados_actualizacion.contratistas
                          .count
                  }}
                </td>
              </tr>
              <tr>
                <td
                  :class="{ border_red: step === 0 && hasTutorial() === false }"
                  style="background-color: #e36d33; color: white"
                  class="border"
                >
                  N° de Inventarios en Revisión
                  <el-popover
                    placement="top-start"
                    title="N° de Inventarios en Revisión"
                    width="400"
                    trigger="hover"
                    :content="`Cantidad total de inventarios en revisión asignados a su cuenta`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td
                  :class="{ border_red: step === 0 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_revision.propios.count
                  }}
                </td>
                <td
                  :class="{ border_red: step === 0 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_revision.contratistas.count
                  }}
                </td>
              </tr>
              <tr>
                <td
                  :class="{ border_red: step === 4 && hasTutorial() === false }"
                  class="border"
                  style="background-color: #424242; color: white"
                >
                  N° de Inventarios en Borrador
                  <el-popover
                    placement="top-start"
                    title="N° de Inventarios en Borrador"
                    width="400"
                    trigger="hover"
                    :content="`Visualización de la cantidad total de inventarios que se encuentran en borrador asociados a su cuenta, que aún están en proceso de llenado y no se ha enviado para revisión`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td
                  :class="{ border_red: step === 4 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_borrador.propios.count
                  }}
                </td>
                <td
                  :class="{ border_red: step === 4 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_borrador.contratistas.count
                  }}
                </td>
              </tr>
              <tr>
                <td class="border" style="background-color: rgb(253 225 159)">
                  Nº Inventarios en Borrador en validación de Medio Ambiente
                  <el-popover
                    placement="top-start"
                    title="Nº Inventarios en Borrador en validación de Medio Ambiente"
                    width="400"
                    trigger="hover"
                    :content="`Número de inventarios en borrador que requieren la revisión de un especialista de medio ambiente de la compañía para que el estado del inventario pase a revisión.`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td class="border status-text">
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_ma.propios.count
                  }}
                </td>
                <td class="border status-text">
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_ma.contratistas.count
                  }}
                </td>
              </tr>
              <tr>
                <td
                  :class="{ border_red: step === 5 && hasTutorial() === false }"
                  style="background-color: #b5b5b5"
                  class="border"
                >
                  N° de Inventarios No Iniciados
                  <el-popover
                    placement="top-start"
                    title="N° de Inventarios No Iniciados"
                    width="400"
                    trigger="hover"
                    :content="`Visualización de la cantidad de inventarios no iniciados asociados a su cuenta, es decir, aquellos inventarios en donde se ha creado el contrato y aun no se ha completado el resto de la información necesaria para enviar a borrador`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td
                  :class="{ border_red: step === 5 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_no_iniciado.propios.count
                  }}
                </td>
                <td
                  :class="{ border_red: step === 5 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_no_iniciado.contratistas.count
                  }}
                </td>
              </tr>
              <tr>
                <td
                  :class="{ border_red: step === 7 && hasTutorial() === false }"
                  style="background-color: #bce085"
                  class="border"
                >
                  N° de Riesgos Aprobados
                  <el-popover
                    placement="top-start"
                    title="N° de Riesgos Aprobados"
                    width="400"
                    trigger="hover"
                    :content="`Visualización de la cantidad de riesgos aprobados asociados a su cuenta; que han pasado por los diferentes flujos de revisión y que han sido aprobados`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td
                  :class="{ border_red: step === 7 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_aprobados.propios.risk.count
                  }}
                </td>
                <td
                  :class="{ border_red: step === 7 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_aprobados.contratistas.risk.count
                  }}
                </td>
              </tr>
              <tr>
                <td
                  :rowspan="2"
                  :class="{ border_red: step === 2 && hasTutorial() === false }"
                  class="border"
                  style="background-color: #dba72c"
                >
                  N° Total de Riesgos en Revisión
                  <el-popover
                    placement="top-start"
                    title="N° Total de Riesgos en Revisión"
                    width="400"
                    trigger="hover"
                    :content="`Cantidad de riesgos totales pendientes de revisión asociados a su cuenta`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td
                  :class="{ border_red: step === 2 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_revision.propios.risk.count
                  }}
                </td>
                <td
                  :class="{ border_red: step === 2 && hasTutorial() === false }"
                  class="border status-text"
                >
                  {{
                    JSON.stringify(status_inv) === "{}"
                      ? ""
                      : status_inv.count_inv_revision.contratistas.risk.count
                  }}
                </td>
              </tr>
              <tr>
                <td
                  :class="{ border_red: step === 3 && hasTutorial() === false }"
                  class="border text-center"
                  style="padding: 0px !important"
                >
                  <table cellspacing="0">
                    <tr>
                      <td>
                        <el-button
                          size="small"
                          :class="{
                            intermitente:
                              JSON.stringify(status_inv) !== '{}' &&
                              status_inv.count_inv_revision.propios.risk.risks
                                .count_menosoigualdiez > 0,
                          }"
                          @click="
                            setPendingRisks(
                              status_inv.count_inv_revision.propios.risk.risks
                                .menosoigualdiez,
                              'count_inv_revision.propios.risk.risks.menosoigualdiez'
                            )
                          "
                        >
                          <div style="margin-bottom: 10px">
                            Menores a 10 días
                          </div>
                          <b>
                            <span
                              class="red-text"
                              style="font-size: 20px !important"
                              >{{
                                JSON.stringify(status_inv) === "{}"
                                  ? ""
                                  : status_inv.count_inv_revision.propios.risk
                                      .risks.count_menosoigualdiez
                              }}</span
                            >
                          </b>
                        </el-button>
                      </td>
                      <td style="border-left: 2px solid black">
                        <el-button
                          size="small"
                          :class="{
                            intermitente:
                              JSON.stringify(status_inv) !== '{}' &&
                              status_inv.count_inv_revision.propios.risk.risks
                                .count_masdiez > 0,
                          }"
                          @click="
                            setPendingRisks(
                              status_inv.count_inv_revision.propios.risk.risks
                                .masdiez,
                              'count_inv_revision.propios.risk.risks.masdiez'
                            )
                          "
                        >
                          <div style="margin-bottom: 10px">
                            Mayores a 10 días
                          </div>
                          <b>
                            <span
                              class="red-text"
                              style="font-size: 20px !important"
                              >{{
                                JSON.stringify(status_inv) === "{}"
                                  ? ""
                                  : status_inv.count_inv_revision.propios.risk
                                      .risks.count_masdiez
                              }}</span
                            >
                          </b>
                        </el-button>
                      </td>
                    </tr>
                  </table>
                </td>
                <td
                  :class="{ border_red: step === 3 && hasTutorial() === false }"
                  class="border text-center"
                >
                  <table cellspacing="0">
                    <tr>
                      <td>
                        <el-button
                          size="small"
                          :class="{
                            intermitente:
                              JSON.stringify(status_inv) !== '{}' &&
                              status_inv.count_inv_revision.contratistas.risk
                                .risks.count_menosoigualdiez > 0,
                          }"
                          @click="
                            setPendingRisks(
                              status_inv.count_inv_revision.contratistas.risk
                                .risks.menosoigualdiez,
                              'count_inv_revision.contratistas.risk.risks.menosoigualdiez'
                            )
                          "
                        >
                          <div style="margin-bottom: 10px">
                            Menores a 10 días
                          </div>
                          <b>
                            <span
                              class="red-text"
                              style="font-size: 20px !important"
                              >{{
                                JSON.stringify(status_inv) === "{}"
                                  ? ""
                                  : status_inv.count_inv_revision.contratistas
                                      .risk.risks.count_menosoigualdiez
                              }}</span
                            >
                          </b>
                        </el-button>
                      </td>
                      <td style="border-left: 2px solid black">
                        <el-button
                          size="small"
                          :class="{
                            intermitente:
                              JSON.stringify(status_inv) !== '{}' &&
                              status_inv.count_inv_revision.contratistas.risk
                                .risks.count_masdiez > 0,
                          }"
                          @click="
                            setPendingRisks(
                              status_inv.count_inv_revision.contratistas.risk
                                .risks.masdiez,
                              'count_inv_revision.contratistas.risk.risks.masdiez'
                            )
                          "
                        >
                          <div style="margin-bottom: 10px">
                            Mayores a 10 días
                          </div>
                          <b>
                            <span
                              class="red-text"
                              style="font-size: 20px !important"
                              >{{
                                JSON.stringify(status_inv) === "{}"
                                  ? ""
                                  : status_inv.count_inv_revision.contratistas
                                      .risk.risks.count_masdiez
                              }}</span
                            >
                          </b>
                        </el-button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td
                  :rowspan="2"
                  :class="{ border_red: step === 2 && hasTutorial() === false }"
                  class="border"
                  style="background-color: rgb(239 148 148)"
                >
                  N° de Riesgos Críticos en Revisión
                  <el-popover
                    placement="top-start"
                    title="N° de Riesgos Críticos en Revisión"
                    width="400"
                    trigger="hover"
                    :content="`Cantidad de Riesgos críticos pendientes de revisión asociados a su cuenta, un riesgo crítico es aquel que tiene al menos un control crítico.`"
                  >
                    <i
                      slot="reference"
                      style="margin-left: 10px"
                      class="el-icon-info"
                    ></i>
                  </el-popover>
                </td>
                <td
                  :class="{ border_red: step === 3 && hasTutorial() === false }"
                  class="border text-center"
                  style="padding: 0px !important"
                >
                  <table cellspacing="0">
                    <tr>
                      <td>
                        <el-button
                          size="small"
                          :class="{
                            intermitente:
                              JSON.stringify(status_inv) !== '{}' &&
                              status_inv.count_inv_revision.propios.risk.risks
                                .count_menosoigualdiezcritico > 0,
                          }"
                          @click="
                            setPendingRisks(
                              status_inv.count_inv_revision.propios.risk.risks
                                .menosoigualdiezcritico,
                              'count_inv_revision.propios.risk.risks.menosoigualdiezcritico'
                            )
                          "
                        >
                          <div style="margin-bottom: 10px">
                            Menores a 10 días
                          </div>
                          <b>
                            <span
                              class="red-text"
                              style="font-size: 20px !important"
                              >{{
                                JSON.stringify(status_inv) === "{}"
                                  ? ""
                                  : status_inv.count_inv_revision.propios.risk
                                      .risks.count_menosoigualdiezcritico
                              }}</span
                            >
                          </b>
                        </el-button>
                      </td>
                      <td style="border-left: 2px solid black">
                        <el-button
                          size="small"
                          :class="{
                            intermitente:
                              JSON.stringify(status_inv) !== '{}' &&
                              status_inv.count_inv_revision.propios.risk.risks
                                .count_masdiezcritico > 0,
                          }"
                          @click="
                            setPendingRisks(
                              status_inv.count_inv_revision.propios.risk.risks
                                .masdiezcritico,
                              'count_inv_revision.propios.risk.risks.masdiezcritico'
                            )
                          "
                        >
                          <div style="margin-bottom: 10px">
                            Mayores a 10 días
                          </div>
                          <b>
                            <span
                              class="red-text"
                              style="font-size: 20px !important"
                              >{{
                                JSON.stringify(status_inv) === "{}"
                                  ? ""
                                  : status_inv.count_inv_revision.propios.risk
                                      .risks.count_masdiezcritico
                              }}</span
                            >
                          </b>
                        </el-button>
                      </td>
                    </tr>
                  </table>
                </td>
                <td
                  :class="{ border_red: step === 3 && hasTutorial() === false }"
                  class="border text-center"
                >
                  <table cellspacing="0">
                    <tr>
                      <td>
                        <el-button
                          size="small"
                          :class="{
                            intermitente:
                              JSON.stringify(status_inv) !== '{}' &&
                              status_inv.count_inv_revision.contratistas.risk
                                .risks.count_menosoigualdiezcritico > 0,
                          }"
                          @click="
                            setPendingRisks(
                              status_inv.count_inv_revision.contratistas.risk
                                .risks.menosoigualdiezcritico,
                              'count_inv_revision.contratistas.risk.risks.menosoigualdiezcritico'
                            )
                          "
                        >
                          <div style="margin-bottom: 10px">
                            Menores a 10 días
                          </div>
                          <b>
                            <span
                              class="red-text"
                              style="font-size: 20px !important"
                              >{{
                                JSON.stringify(status_inv) === "{}"
                                  ? ""
                                  : status_inv.count_inv_revision.contratistas
                                      .risk.risks.count_menosoigualdiezcritico
                              }}</span
                            >
                          </b>
                        </el-button>
                      </td>
                      <td style="border-left: 2px solid black">
                        <el-button
                          size="small"
                          :class="{
                            intermitente:
                              JSON.stringify(status_inv) !== '{}' &&
                              status_inv.count_inv_revision.contratistas.risk
                                .risks.count_masdiezcritico > 0,
                          }"
                          @click="
                            setPendingRisks(
                              status_inv.count_inv_revision.contratistas.risk
                                .risks.masdiezcritico,
                              'count_inv_revision.contratistas.risk.risks.masdiezcritico'
                            )
                          "
                        >
                          <div style="margin-bottom: 10px">
                            Mayores a 10 días
                          </div>
                          <b>
                            <span
                              class="red-text"
                              style="font-size: 20px !important"
                              >{{
                                JSON.stringify(status_inv) === "{}"
                                  ? ""
                                  : status_inv.count_inv_revision.contratistas
                                      .risk.risks.count_masdiezcritico
                              }}</span
                            >
                          </b>
                        </el-button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </el-col>
          <el-col
            :md="6"
            :offset="1"
            class="intermitente"
            v-if="hasTutorial() === false && loading === false"
          >
            <el-alert
              style="margin-top: 9px; width: 100%"
              :title="title"
              type="info"
              :description="text_step"
              show-icon
            ></el-alert>
            <br />
            <center>
              <el-button
                v-if="step < 7"
                @click="nextStep"
                size="medium"
                type="primary"
              >
                Siguiente
                <i class="el-icon-arrow-right"></i>
              </el-button>
              <el-button
                v-else
                @click="endTutorial"
                size="medium"
                type="primary"
                >Finalizar</el-button
              >
            </center>
          </el-col>
        </el-row>
        <br />
        <div style="margin-left: 10px; margin-top: 10px">
          <span style="color: #ed7d31; font-size: 13px">
            <b>Responsabilidades de los Roles creados en la Plataforma:</b>
          </span>
          <br />
          <br />
          <table border="1" style="font-size: 13px" cellspacing="0">
            <tr>
              <td>
                <b>Rol</b>
              </td>
              <td>
                <b>Permisos</b>
              </td>
            </tr>
            <tr>
              <td rowspan="4">
                (1) Coordinador Empresa Colaboradora y Coordinador Minera
                Escondida
              </td>
              <td>
                → Puede ingresar, editar, eliminar información del inventario de
                riesgo asignado a usted, sólo cuando el inventario se encuentra
                en estado
                <b>BORRADOR</b>.
              </td>
            </tr>
            <tr>
              <td>→ Puede enviar a revisión el Inventario asignado.</td>
            </tr>
            <tr>
              <td>
                → Puede corregir uno o más riesgos, que fueron rechazados.
              </td>
            </tr>
            <tr>
              <td>
                → Puede cambiar el estado de un Inventario de APROBADO a
                BORRADOR para actualizarlo.
              </td>
            </tr>
            <tr>
              <td>(2) Administrador Empresa Colaboradora</td>
              <td rowspan="7">
                → Puede aprobar o rechazar los riesgos niveles del 1 al 5, sólo
                cuando el inventario se encuentra en estado en revisión.
              </td>
            </tr>
            <tr>
              <td>(3) Asesor HSE Empresa Colaboradora:</td>
            </tr>
            <tr>
              <td>
                (4) Especialista de Salud, de Seguridad y de Medio Ambiente de
                la Compañía
              </td>
            </tr>
            <tr>
              <td>(5) Especialista de Riesgos de la Compañía</td>
            </tr>
            <tr>
              <td>(6) Superintendente de la Compañía</td>
            </tr>
            <tr>
              <td>(7) Gerente de Área de la Compañía</td>
            </tr>
            <tr>
              <td>(8) Contract Owner de Compañía</td>
            </tr>
          </table>
          <br />
        </div>
      </el-tab-pane>
      <el-tab-pane class="paddingBody content" :label="$t('Estadísticas')">
        <el-row :gutter="25">
          <el-col :md="8">
            Seleccione sus áreas:<br />
            <el-select
              collapse-tags
              filterable
              multiple
              @change="getAllInventarios"
              style="margin-top: 10px; width: 100%"
              v-model="area_selected"
              placeholder="Seleccione área"
            >
              <el-option
                v-for="item in listado_areas"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <el-button
              style="margin-top: 10px"
              type="primary"
              size="small"
              @click="allAreas"
              >Seleccionar todo</el-button
            >
          </el-col>
          <el-col :md="11">
            Seleccione sus inventarios:<br />
            <el-select
              collapse-tags
              v-loading="loading_inv"
              filterable
              @change="getEstadistica"
              :disabled="area_selected.length === 0"
              multiple
              style="margin-top: 10px; width: 100%"
              v-model="inventarios_selected"
              placeholder="Seleccione los inventarios"
            >
              <el-option
                v-for="item in listado_inventarios"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <el-button
              style="margin-top: 10px"
              type="primary"
              size="small"
              @click="allInventarios"
              >Seleccionar todo</el-button
            >
          </el-col>
          <el-col :md="4">
            <br />
            <el-checkbox
              @change="getEstadistica"
              :disabled="
                area_selected.length === 0 || inventarios_selected.length === 0
              "
              style="margin-top: 10px"
              v-model="estandarizados"
              label="Incluír riesgos estandarizados"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <br /><br /><br />
        <el-row :gutter="25" v-if="inventarios_selected.length > 0">
          <el-col :md="8">
            <el-card
              v-loading="loading_data"
              header="TOP 3 - Tareas con más controles críticos"
            >
              <apexchart
                @click="clickHandlerTareas"
                :key="render_graph"
                type="bar"
                height="350"
                :options="chartOptions_1"
                :series="series_1"
              ></apexchart>
            </el-card>
          </el-col>
          <el-col :md="8">
            <el-card
              v-loading="loading_data"
              header="TOP 3 - Riesgos con más controles críticos"
            >
              <apexchart
                @click="clickHandlerRiesgos"
                :key="render_graph"
                type="bar"
                height="350"
                :options="chartOptions_2"
                :series="series_2"
              ></apexchart>
            </el-card>
          </el-col>
          <el-col :md="8">
            <el-card
              v-loading="loading_data"
              header="TOP 3 - Controles críticos más repetidos"
            >
              <apexchart
                @click="clickHandlerControl"
                :key="render_graph"
                type="bar"
                height="350"
                :options="chartOptions_3"
                :series="series_3"
              ></apexchart>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :title="$t('Estadísticas')"
      :visible="dialogEstadistica"
      width="70%"
    >
      <el-table
        height="400"
        :key="refresh"
        :data="estadistica.data.datos"
        style="width: 100%; margin-top: 15px"
      >
        <el-table-column type="index"> </el-table-column>
        <el-table-column prop="tarea" label="Tarea"> </el-table-column>
        <el-table-column prop="riesgo" label="Riesgo"> </el-table-column>
        <el-table-column prop="control" label="Control crítico">
        </el-table-column>
        <el-table-column prop="tipo_control" label="Tipo Control">
        </el-table-column>
        <el-table-column prop="contrato" label="Contrato">
          <template slot-scope="scope">
            {{ scope.row.contrato.nombre }}
          </template>
        </el-table-column>
        <el-table-column align="center" width="200" label="Ver Inventario">
          <template slot-scope="scope">
            <el-button
              @click="selectContractEstadistica(scope.row)"
              size="medium"
              type="info"
              >Visualizar</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="medium"
          @click="dialogEstadistica = false"
          >{{ $t("Cerrar") }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="
        $t(
          'Anuncio de nuevo riesgo estandarizado en Plataforma Inventario de riesgos HSE'
        )
      "
      :visible="dialogo_nuevos_riesgos"
      width="70%"
    >
      <p>
        Estimad@ Usuario, <br /><br />
        Junto con saludarlo, como equipo desarrollador y soporte de la
        plataforma en conjunto a BHP es de suma importancia informar que en la
        actualidad se han cargado <b>nuevos riesgos estandarizados</b> en
        plataforma inventario de riesgos HSE Online. <br /><br />
        Los <b>riesgos</b> son los siguientes:
        <li v-for="(riesgo, i) in riesgos_nuevos" :key="`RN-${i}`">
          {{ riesgo.nombre }}
        </li>
        <br /><br />
        En caso de que se encuentren expuestos a dichos riesgos, ya sea por el
        servicio o actividades que realizan, ahora podrán agregarlos en la
        creación y/o actualización de sus <b>inventarios de riesgos</b>.
        <br /><br />
        Saludos Cordiales.
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          size="medium"
          @click="dialogo_nuevos_riesgos = false"
          >{{ $t("Cerrar") }}</el-button
        >
        <el-button
          :loading="loading_no_mostrar"
          type="primary"
          size="medium"
          @click="noVolverAmostrar()"
          >{{ $t("No volver a Mostrar") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { Circle9 } from "vue-loading-spinner";
import axios from "axios";

export default {
  data() {
    return {
      loading_no_mostrar: false,
      dialogo_nuevos_riesgos: false,
      riesgos_nuevos: [],
      refresh: 0,
      dialogEstadistica: false,
      estadistica: {
        tipo: "",
        data: [],
      },
      estandarizados: false,
      loading_data: false,
      loading_inv: false,
      inventarios_selected: [],
      listado_inventarios: [],
      area_selected: [],
      listado_areas: [],
      render_graph: 0,
      nombre_inv: "",
      id_inventory: "",
      status: {
        4: "Validación de Medioambiente",
      },
      step: 0,
      title: "",
      text_step: "",
      render: 0,
      bhpProfiles: {
        hse: "HSE",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        owner: "Dueño de Contrato",
        contract_owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        administrator: "Administrador de Contrato",
        contractor_coordinator: "Coordinador Contratista",
        coordinator: "Coordinador",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
        superadmin: "Administrador del sistema",
      },
      status_inv: {},
      loading: false,
      estadisticas: [],
      faenas: {
        "5a6f78337b772dcfe68241d5": "Minera Escondida",
        "5a6f78417b772dcfe68241e5": "Minera Spence",
        "5a6f784e7b772dcfe68241f4": "Minera Cerro Colorado",
        "5b48f15d6f0ed90fc02826e3": "BHP",
        "5c262b3176851b775b8bdefc": "Safety Club",
      },
      series_1: [
        {
          name: "Cantidad de riesgos críticos",
          data: [],
        },
      ],
      series_2: [
        {
          name: "Cantidad de riesgos críticos",
          data: [],
        },
      ],
      series_3: [
        {
          name: "Cantidad de repeticiones",
          data: [],
        },
      ],
      chartOptions_1: {
        colors: ["#dd5b32"],
        chart: {
          type: "bar",
          height: "auto",
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
      },
      chartOptions_2: {
        colors: ["#242424"],
        chart: {
          type: "bar",
          height: "auto",
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
      },
      chartOptions_3: {
        colors: ["#546E7A"],
        chart: {
          type: "bar",
          height: "auto",
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  components: {
    Circle9,
  },
  async mounted() {
    this.$store.dispatch("setSubTitle", this.$t("Dashboard Personal"));
    if (this.$store.getters.empresas.length === 0) {
      this.$store.dispatch("getEmpresasFaena");
    }
    if (this.$store.getters.all_risk_pending === null) {
      this.getStatus();
    } else {
      this.status_inv = this.$store.getters.all_risk_pending;
    }
    /* TUTORIAL */
    if (this.hasTutorial() === false) {
      this.text_step =
        "Cantidad total de inventarios en revisión asignados a su cuenta";
      this.title = "N° de Inventarios en Revisión";
      /* this.$alert(
        "Estimado usuario junto con saludarle le informamos que se ha modificado el dashboard personal con el fin de facilitarle su trabajo y su experiencia de usuario. se ha implementado un breve tutorial para comentar las mejoras que se han implementado.",
        "Información Importante",
        {
          confirmButtonText: "Aceptar"
        }
      ); */
    }
    if (localStorage.getItem("tutorial") === "false") {
      localStorage.setItem("tutorial", "false");
    }
    this.getAllAreas();
    this.validarNuevosRiesgos();
  },
  computed: {
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    empresas() {
      return this.$store.getters.empresas;
    },
  },
  methods: {
    allAreas() {
      var areas = this.listado_areas.map((a) => a._id);
      this.area_selected = areas;
      this.getAllInventarios();
    },
    allInventarios() {
      var inventarios = this.listado_inventarios.map((a) => a._id);
      this.inventarios_selected = inventarios;
      this.getEstadistica();
    },
    async noVolverAmostrar() {
      this.loading_no_mostrar = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var response = await axios.post(
        "/inventarios/noMostrarNuevosRiesgos/",
        {
          riesgos_nuevos: this.riesgos_nuevos,
          user_id: this.$store.getters.user._id,
        },
        config
      );

      if (response.status) {
        this.loading_no_mostrar = false;
        this.dialogo_nuevos_riesgos = false;
      } else {
        this.loading_no_mostrar = false;
        this.$alert(response.error, "Atención", {
          type: "error",
        });
      }
    },
    async validarNuevosRiesgos() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var response = await axios.post(
        "/inventarios/validarNuevosRiesgos/",
        {
          user_id: this.$store.getters.user._id,
          faena_id: this.$store.getters.role.faena_id,
        },
        config
      );
      if (response.data.length > 0) {
        this.riesgos_nuevos = response.data;
        this.dialogo_nuevos_riesgos = true;
      } else {
        this.riesgos_nuevos = [];
        this.dialogo_nuevos_riesgos = false;
      }
    },
    selectContractEstadistica(d) {
      let url = `/inventario/${d.contrato._id}/ver`;
      if (d.status) {
        switch (parseInt(d.status, 10)) {
          case 1:
            url = `/inventario/${d.contrato._id}/revisar`;
          case 4:
            url = `/inventario/${d.contrato._id}/revisar`;
            break;
          case 2:
            url = `/inventario/${d.contrato._id}/ver`;
            break;
          case 0:
          case 3:
          default:
            url = `/inventario/${d.contrato._id}/editar`;
        }
      }
      this.$router.push({
        path: url,
      });
    },
    clickHandlerTareas(event, chartContext, config) {
      if (this.estadisticas["top_cinco_tareas"][config.dataPointIndex]) {
        this.estadistica = {
          tipo: "tarea",
          data: this.estadisticas["top_cinco_tareas"][config.dataPointIndex],
        };
        this.dialogEstadistica = true;
        this.refresh++;
      }
    },
    clickHandlerRiesgos(event, chartContext, config) {
      if (this.estadisticas["top_cinco_riesgos"][config.dataPointIndex]) {
        this.estadistica = {
          tipo: "riesgo",
          data: this.estadisticas["top_cinco_riesgos"][config.dataPointIndex],
        };
        this.dialogEstadistica = true;
        this.refresh++;
      }
    },
    clickHandlerControl(event, chartContext, config) {
      if (this.estadisticas["top_cinco_controles"][config.dataPointIndex]) {
        this.estadistica = {
          tipo: "control",
          data: this.estadisticas["top_cinco_controles"][config.dataPointIndex],
        };
        this.dialogEstadistica = true;
        this.refresh++;
      }
    },
    isAdmin() {
      if (!this.$store.getters.role) return false;
      return this.$store.getters.role.admin || false;
    },
    async getAllInventarios() {
      this.inventarios_selected = [];
      this.estandarizados = false;
      this.loading_inv = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var self = this;
      var response = await axios.post(
        "/contratos/getContratosByArea/",
        {
          areas: self.area_selected,
        },
        config
      );
      self.listado_inventarios = response.data;
      this.loading_inv = false;
    },
    async getAllAreas() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var self = this;
      var response = await axios.get(
        "/areas/getAllAreasFaena/" + this.$store.getters.role.faena_id,
        config
      );
      self.listado_areas = response.data;
    },
    async getEstadistica() {
      this.loading_data = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var self = this;
      var response = await axios.post(
        "/inventarios/getDataCriticos",
        {
          contratos: self.inventarios_selected,
          estandarizados: self.estandarizados,
        },
        config
      );
      self.estadisticas = response.data;

      self.series_1[0]["data"] = self.estadisticas["top_cinco_tareas"].map(
        (e) => e.cantidad
      );
      self.chartOptions_1.xaxis.categories = self.estadisticas[
        "top_cinco_tareas"
      ].map((e) => e.nombre);

      self.series_2[0]["data"] = self.estadisticas["top_cinco_riesgos"].map(
        (e) => e.cantidad
      );
      self.chartOptions_2.xaxis.categories = self.estadisticas[
        "top_cinco_riesgos"
      ].map((e) => e.nombre);

      self.series_3[0]["data"] = self.estadisticas["top_cinco_controles"].map(
        (e) => e.cantidad
      );
      self.chartOptions_3.xaxis.categories = self.estadisticas[
        "top_cinco_controles"
      ].map((e) => e.nombre);

      self.render_graph++;

      this.loading_data = false;
    },
    isActiveContract(contract) {
      if (contract.tipo_contrato === "Propio") return true;
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    hasTutorial() {
      if (localStorage.getItem("tutorial") === "true") {
        return true;
      }
      return false;
    },
    endTutorial() {
      this.$confirm(
        "¿Desea ocultar este tutorial en sus próximas sesiones?",
        "Información",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        localStorage.setItem("tutorial", "true");
        this.render++;
      });
    },
    nextStep() {
      this.step++;
      switch (this.step) {
        case 0:
          this.title = "N° de Inventarios en Revisión";
          this.text_step =
            "Cantidad total de inventarios en revisión asignados a su cuenta.";
          break;
        case 1:
          this.title = "N° de Inventarios Aprobados en Actualización ";
          this.text_step =
            "Aquí usted podrá visualizar la cantidad de inventarios aprobados que se encuentran en proceso de modificación o bien ya modificados, pero en estado de revisión.";
          break;
        case 2:
          this.title = "N° de Riesgos en Revisión";
          this.text_step =
            "Cantidad de Riesgos pendientes de revisión asociados a su cuenta.";
          break;
        case 3:
          this.title = "Detalle de Riesgos en Revisión";
          this.text_step =
            "Visualización de la cantidad de riesgos pendientes que tiene en revisión, estos se dividen en dos categorías 'Menores a 10 Días' y 'Mayores a 10 Días', tanto en Minera Spence como en empresas colaboradoras, si necesita revisar riesgos pendientes solamente debe hacer click en cualquiera de los 4 botones según sea su necesidad.";
          break;
        case 4:
          this.title = "N° de Inventarios en Borrador";
          this.text_step =
            "Visualización de la cantidad total de inventarios que se encuentran en borrador asociados a su cuenta, que aún están en proceso de llenado y no se ha enviado para revisión.";
          break;
        case 5:
          this.title = "N° de Inventarios No Iniciados";
          this.text_step =
            "Visualización de la cantidad de inventarios no iniciados asociados a su cuenta, es decir, aquellos inventarios en donde se ha creado el contrato y aun no se ha completado el resto de la información necesaria para enviar a borrador.";
          break;
        case 6:
          this.title = "N° de Inventarios Aprobados";
          this.text_step =
            "Visualización de la cantidad de Inventarios aprobados asociados a su cuenta; que ya pasaron por los diferentes flujos de revisión y tienen todos sus riesgos aprobados.";
          break;
        case 7:
          this.title = "N° de Riesgos Aprobados";
          this.text_step =
            "Visualización de la cantidad de riesgos aprobados asociados a su cuenta; que han pasado por los diferentes flujos de revisión y que han sido aprobados.";
          break;

        default:
          break;
      }
    },
    setPendingRisks(risks, structure) {
      this.$store.dispatch("setRiesgosPendientes", {
        risks,
        structure,
      });
      this.$router.push({ name: "riesgosPendientes" });
    },
    areaName(id) {
      if (this.$store.getters.areasRoles) {
        const area = this.$store.getters.areasRoles.find((a) => a._id === id);
        return area ? area.nombre : id;
      }
      ("");
    },
    companyName(id) {
      if (this.empresas) {
        const empresa = this.empresas.find((x) => x._id === id);
        if (empresa && empresa.nombre) {
          return empresa.nombre;
        }
      } else {
        return "";
      }
    },
    getStatus() {
      this.loading = true;
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const role =
        this.$store.getters.role.admin === true
          ? "superadmin"
          : this.$store.getters.role.role;
      axios
        .get(
          `/inventarios/getStatusDashboard/${this.$store.getters.role.faena_id}/${role}/${this.$store.getters.user._id}/${this.$store.getters.role.area_id}/${this.$store.getters.role.empresa_id}`,
          config
        )
        .then((response) => {
          // handle success
          self.status_inv = response.data;
          self.$store.dispatch("setAllRiesgosPendientes", response.data);
          self.loading = false;
        })
        .catch((error) => {
          // handle error
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.status-text {
  text-align: center;
  font-weight: bold;
  font-size: 16px !important;
}

.color-bhp-text {
  color: rgb(246, 123, 47);
  font-weight: bold;
}

.fondo-amarillo-a {
  background-color: #727997;
  color: white;
}

.fondo-amarillo-b {
  background-color: #62636b;
  color: white;
}

.fondo-green-b {
  background-color: green;
  color: white;
}

.fondo-verde-a {
  background-color: rgb(246, 123, 47);
  color: white;
}

td {
  padding: 5px;
}

.border {
  border: 1px solid black;
}

.content {
  min-height: 50vh;
}

.text-center {
  text-align: center;
}

.red-text {
  color: red;
}

.border_red {
  border: 4px solid red;
}

.username {
  color: #ed7d31;
  font-size: 24px;
}

.content-username {
  margin-left: 21px;
  text-align: center;
  max-width: 990px;
}

.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {
  0%,
  100% {
    box-shadow: 0px 0px 10px #ed7d31;
  }

  50% {
    box-shadow: 0px 0px 0px #ed7d31;
  }
}
</style>

<style>
.el-alert__description {
  font-size: 15px !important;
  color: black !important;
}

.el-alert__title {
  font-size: 15px !important;
  color: black !important;
}

.el-alert__content {
  padding: 10px !important;
}
</style>
